"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerButton = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var utils_1 = require("./utils");
var Buttons_1 = require("../Buttons");
var smartDate_1 = require("./smartDate");
exports.DatePickerButton = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, onClick = _a.onClick, _b = _a.darkMode, darkMode = _b === void 0 ? false : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c, smartDate = _a.smartDate, isRange = _a.isRange, includeDropdownButton = _a.includeDropdownButton, _d = _a.isClearable, isClearable = _d === void 0 ? false : _d, _e = _a.onClearClick, onClearClick = _e === void 0 ? noop_1.default : _e, _f = _a.labelFormat, labelFormat = _f === void 0 ? 'MM/dd/yyyy' : _f, showEndDate = _a.showEndDate;
    var isInceptionSmartDate = smartDate === smartDate_1.SmartDateTypeOptions.sinceInception ||
        smartDate === smartDate_1.SmartDateTypeOptions.inceptionToLastMonth;
    var fromDate = isInceptionSmartDate
        ? 'Inception'
        : utils_1.formatDate(startDate, labelFormat);
    var displayedEndDate = utils_1.formatDate(endDate, labelFormat);
    var generateDateLabel = function () {
        if (isRange)
            return fromDate + " - " + displayedEndDate;
        if (showEndDate)
            return displayedEndDate;
        return fromDate;
    };
    var dateLabel = generateDateLabel();
    return (react_1.default.createElement(StyledButton, { buttonStyle: "SECONDARY", "data-testid": "datepicker-button", icon: "calendar_date", darkMode: darkMode, isActive: isActive, isDropdownOpen: isActive, includeDropdownButton: includeDropdownButton, onClick: onClick, isClearable: isClearable, onClearClick: onClearClick },
        react_1.default.createElement(StyledValue, null, dateLabel)));
};
var StyledValue = styled_components_1.default.span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-family: ", ";\n  font-size: 1.2rem;\n"], ["\n  font-family: ", ";\n  font-size: 1.2rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
});
var StyledButton = styled_components_1.default(function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode, rest = tslib_1.__rest(_a, ["theme", "darkMode"]);
    return (react_1.default.createElement(Buttons_1.Button, tslib_1.__assign({}, rest)));
})(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  && {\n    text-transform: capitalize;\n    border-color: ", ";\n    ", ";\n    background-color: ", ";\n    color: ", ";\n    :hover {\n      border-color: ", ";\n      ", ";\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"], ["\n  && {\n    text-transform: capitalize;\n    border-color: ",
    ";\n    ", ";\n    background-color: ",
    ";\n    color: ",
    ";\n    :hover {\n      border-color: ",
    ";\n      ", ";\n      background-color: ",
    ";\n      color: ",
    ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? theme.colors.NTDarkGrey[800] : theme.colors.NTDarkGrey[300];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? theme.colors.NTDarkGrey[800] : theme.colors.white;
}, function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? 'white' : theme.colors.NTDarkGrey[800];
}, function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? theme.colors.NTDarkGrey[800] : theme.colors.NTDarkGrey[300];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? theme.colors.NTDarkGrey[800] : theme.colors.white;
}, function (_a) {
    var theme = _a.theme, darkMode = _a.darkMode;
    return darkMode ? 'white' : theme.colors.NTDarkGrey[800];
});
var templateObject_1, templateObject_2;
